export default {
    name: "todo-list",
    data() {
        return {
            isLoading: true,
            currentPage: 1,
            perPage: parseInt(this.postsPerPage),
            posts: this.json.posts,
            categories: this.json.cats,
            currentCats: [],
            viewAll: false,
        }
    },

    props: {
        json: Object,
        postsPerPage: [String, Number],
        placeholder: [String],
    },

    watch: {
        currentCats(newVal, oldVal) {
            this.currentPage = 1;
            // this.viewAll = false;
        },
    },

    computed: {
        postsList() {
            let posts = this.posts

            if (this.currentCats.length) {
                posts = posts.filter(post => {
                    return this.currentCats.every(cat => post.categories.includes(cat));
                    // return post.categories.some(cat => this.currentCats.includes(cat));
                })
            }

            return posts
        },

        printedPosts() {
            const start = this.currentPage * this.perPage - this.perPage,
                end = this.currentPage * this.perPage;

            if (this.viewAll) {
                return this.postsList.slice(start, this.posts.length)
            } else {
                return this.postsList.slice(start, end)
            }

        },

        postsAmount() {
            return this.posts.length
        },

        pages() {
            return Math.round(this.postsList.length / this.perPage);
        },
    },

    methods: {
        loadMore() {
            this.currentPage = 1;
            this.viewAll = true;
        },
        mapCategory(selectedCategory) {
            if (selectedCategory == 'All') {
                this.currentCats = [];
            } else {
                const catIndex = this.currentCats.indexOf(selectedCategory);
                if (catIndex > -1) {
                    this.currentCats = [];
                } else {
                    this.currentCats = [];
                    this.currentCats.push(selectedCategory);
                }
            }

        }
    },
}